
import { useState } from "react";
import { Link } from "react-router-dom";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { BlogPostCard } from "@/components/blog/BlogPostCard";
import { blogPosts } from "@/data/blogPosts";

export function BlogList() {
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");
  
  // Filter posts by category and search term
  const filteredPosts = blogPosts.filter(post => {
    const matchesCategory = filter === "all" || post.category === filter;
    const matchesSearch = search === "" || 
      post.title.toLowerCase().includes(search.toLowerCase()) || 
      post.excerpt.toLowerCase().includes(search.toLowerCase());
    
    return matchesCategory && matchesSearch;
  });
  
  // Get unique categories
  const categories = ["all", ...new Set(blogPosts.map(post => post.category))];
  
  return (
    <div className="animate-fade-in">
      <div className="flex flex-col sm:flex-row gap-4 items-center justify-between mb-8 bg-card/50 p-4 rounded-lg border border-border/30">
        <div className="w-full sm:w-auto">
          <Input
            placeholder="Search posts..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full sm:w-[300px]"
          />
        </div>
        
        <div className="w-full sm:w-auto">
          <Select value={filter} onValueChange={setFilter}>
            <SelectTrigger className="w-full sm:w-[180px]">
              <SelectValue placeholder="Select category" />
            </SelectTrigger>
            <SelectContent>
              {categories.map(category => (
                <SelectItem key={category} value={category}>
                  {category === "all" ? "All Categories" : category}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredPosts.length > 0 ? (
          filteredPosts.map(post => (
            <BlogPostCard key={post.id} post={post} />
          ))
        ) : (
          <div className="text-center py-16 bg-muted/30 rounded-lg border border-border/30 col-span-full">
            <p className="text-muted-foreground">No posts found matching your criteria</p>
          </div>
        )}
      </div>
    </div>
  );
}

